import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BurialSocietiesApiService, FileStorageApiService, IndividualsApiService, KeycloakAuthApiService } from './apis';
import {
  API_CONFIGURATION_TOKEN,
  ApiConfiguration
} from './tokens/api.configuration';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  TokenInterceptorService,
  ErrorInterceptorService
} from './interceptors';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  exports: [HttpClientModule],
  declarations: []
})
export class SharedDataAccessModule {
  static forRoot(configuration: ApiConfiguration): ModuleWithProviders<{}> {
    return {
      ngModule: SharedDataAccessModule,
      providers: [
        {
          provide: API_CONFIGURATION_TOKEN,
          useValue: configuration
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptorService,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptorService,
          multi: true
        },
        BurialSocietiesApiService,
        IndividualsApiService,
        KeycloakAuthApiService,
        FileStorageApiService
      ]
    };
  }
}
